import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import React, { useEffect, useState } from 'react';
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import TopTrainers from "pages/Presentation/sections/TopTrainers";
import ExploreTraining from "pages/Presentation/sections/ExploreTraining";
import LabAsServiceInformation from "pages/Presentation/sections/LabAsServiceInformation";
import defaultRoutes from "routes";
import trainerRoutes from "trainerRoutes";
import trainerEditRoutes from "trainerEditRoutes";
import trainingCompanyRoutes from "trainingCompanyRoutes";
import trainingCompanyEditRoutes from "trainingCompanyEditRoutes";
import footerRoutes from "footer.routes";
import bgImage from "assets/images/background1.jpg";
import AdvertisementCard from "pages/Presentation/sections/AdvertisementCard";
import { useNavigate } from 'react-router-dom';

function Presentation() {

  console.log("process.env.REACT_APP_ADVERTISEMENT", process.env.REACT_APP_ADVERTISEMENT);
  const displayAdvertisement = process.env.REACT_APP_ADVERTISEMENT === 'yes';
  console.log("displayAdvertisement", displayAdvertisement);
  const [trainerProfileCreate, setTrainerProfileCreate] = useState(false);
  const [trainingCompanyProfileCreate, setTrainingCompanyProfileCreate] = useState(false);

  useEffect(() => {
    const userId = localStorage.getItem("userId");

    if (userId) {
      fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofileuidexists/${userId}/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then(response => response.json())
        .then(data => {
          if (data.exists === false) {
            setTrainerProfileCreate(true);
          } else {
            setTrainerProfileCreate(false);
          }
        })
        .catch(error => {
          console.error("Error fetching data:", error);
        });
    }
  }, [localStorage.getItem("userId")]);
  console.log("trainerProfileCreate", trainerProfileCreate);

  useEffect(() => {
    const userId = localStorage.getItem("userId");

    if (userId) {
      fetch(`${process.env.REACT_APP_API_URL}/api/trainingcompanyprofileuidexists/${userId}/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (data.exists === false) {
            setTrainingCompanyProfileCreate(true);
          } else {
            setTrainingCompanyProfileCreate(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [localStorage.getItem("userId")]);
  console.log("trainingCompanyProfileCreate", trainingCompanyProfileCreate);

  const isLoggedIn = localStorage.getItem('user') !== null;
  const userGroup = localStorage.getItem('group');

  console.log("userGroup", userGroup);

  let routes, action;
  const navigate = useNavigate();

  if (!isLoggedIn) {
    routes = defaultRoutes;
    action = {
      type: 'internal',
      route: '/app/signup',
      label: 'Sign Up',
      color: 'info',
    };
  } else {
    if (userGroup === "1") {
      if (trainingCompanyProfileCreate) {
        routes = trainingCompanyRoutes;
        navigate(`/app/trainingcompanyprofile`);
        setTrainingCompanyProfileCreate(false);
      } else {
        routes = trainingCompanyEditRoutes;
        navigate(`/app/trainingcompanydashboard`);
      }
    } else if (userGroup === "2") {
      if (trainerProfileCreate) {
        routes = trainerRoutes;
        navigate(`/app/trainerprofile`);
        setTrainerProfileCreate(false);
      } else {
        routes = trainerEditRoutes;
        navigate(`/app/trainerdashboard`);
      }
    } else {
      routes = defaultRoutes;
      action = {
        type: 'internal',
        route: '/app/signup',
        label: 'Sign Up',
        color: 'info',
      };
    }
  }

  return (
    <>
      <DefaultNavbar routes={routes} action={action} />

      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",          
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="white"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Embark On COLLAB{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="white"
              textAlign="center"
              bgcolor="white"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              Become part of the thriving freelancers' training community
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <MKBox>
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            // backgroundColor: '#FFFFFF', 
            // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <ExploreTraining />
          <TopTrainers />
          <LabAsServiceInformation />
          {displayAdvertisement && <AdvertisementCard />}
        </Card>
      </MKBox>
      <MKBox pt={6} px={1} mt={6} >
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Presentation;
